{
  "meta-title": "Account Details",

  "merge": "Merge",
  "edit-details": "Edit Details",
  "change-account-type": "Change Account Type",
  "update-value": "Update Value",

  "past-values-heading": "Past Values",
  "related-documents": "Related Documents",
  "last-updated": "Last updated {{age}} ago",

  "delete-account-heading": "Delete \"{{name}}?\"",
  "delete-account-body": "Deleting this {{accountType}} will result in its removal from your net worth, as well as the permanent deletion of any historical data associated with this account.",
  "delete-account-button": "Delete {{text}}",

  "close-account": "Close Account",
  "close-account-heading": "Close {{name}}",
  "close-account-body": "Closing this {{accountType}} will remove it from your current calculations. Its full history will be preserved. This cannot be undone.",
  "close-account-button": "Close {{text}}",
  "closed": "Closed",
  "closed-account-banner": "This account is closed. You are viewing historical data.",
  "closed-accounts-section": "Closed Accounts",
  "closed-at": "Archived {{date}}"
}
